import { render, staticRenderFns } from "./AIController.vue?vue&type=template&id=72a0d124&scoped=true"
import script from "./AIController.vue?vue&type=script&lang=js"
export * from "./AIController.vue?vue&type=script&lang=js"
import style0 from "./AIController.vue?vue&type=style&index=0&id=72a0d124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a0d124",
  null
  
)

export default component.exports